import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { NavParams } from "ionic-angular";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";
import { filter, switchMap, take } from "rxjs/operators";
import { CatalogData } from "../../../providers/catalog";
import { GenFormBuilder } from "../../../providers/form";
import { ServiceService } from "../../../providers/services.service";
import { TicketService } from "../../../providers/ticket.service";
import { getClient } from "../../../shared/reducers/shared.reducer";
import { Utilities } from "./../../../providers/utilities";

@Component({
  selector: "app-widgets-right-form",
  templateUrl: "widgets-right-form.html",
})
export class WidgetsRightFormComponent {

  @Input() public widgets: any[];
  @Input() public currentWidget: any;
  @Input() public defaultLanguage: string;
  @Input() public language: string;
  @Input() public widgetList: any[];
  @Output() public languageChange = new EventEmitter();
  @Output() public createOrUpdateWidget = new EventEmitter();

  public dataWidgetOptions$: Observable<any[]>;
  public form: FormGroup;
  public optionsFroala = this.utilities.FroalaKey;
  public submitAttempt = false;

  constructor(
    private formGenerate: GenFormBuilder,
    private formBuilder: FormBuilder,
    private utilities: Utilities,
    private catalogData: CatalogData,
    private ticketData: TicketService,
    private serviceData: ServiceService,
    private store: Store<any>,
    private navParams: NavParams,
  ) { }

  public ngOnInit() {
    this.form = this.formBuilder.group({});

    this.formGenerate.genInputString("id", this.form);
    this.formGenerate.genInputNumber("order", this.form, true, this.widgets.length);
    this.formGenerate.genInputLang("title", this.form, this.defaultLanguage);
    this.formGenerate.genInputString("type", this.form, true);
    this.formGenerate.genInputString("background", this.form);
    this.formGenerate.genInputString("dataWidget", this.form);
    this.form.get("type").valueChanges.subscribe((type) => {
      this.form.get("dataWidget").setValidators(this.getDataWidgetRequired(type));
      this.form.get("dataWidget").updateValueAndValidity();
      this.dataWidgetOptions$ = this.getDataWidgetOptions(type);
    });
    if (this.currentWidget) {
      this.form.patchValue(this.currentWidget);
    }
  }

  public getDataWidgetRequired(type: string) {
    if (type === "rich_text" ||
      type === "slide_banner" ||
      type === "product_sale" ||
      type === "ticket_sale" ||
      type === "service_sale") {
      return Validators.required;
    } else {
      return [];
    }
  }

  public getDataWidgetOptions(type: string): Observable<any> {
    const eventId = this.navParams.get("eventId");
    return this.store.select(getClient)
      .pipe(
        filter((client) => !!client),
        take(1),
        switchMap((client) => {
          switch (type) {
            case "product_sale":
              return this.catalogData.getCatalogActiveByClientId(client.id, eventId);
            case "ticket_sale":
              return this.ticketData.getList(client.id, eventId);
            case "service_sale":
              return this.serviceData.get(client.id, eventId);
            default:
              return of(null);
          }
        }),
      );
  }

  public canShowDataWidgetOptions(type: string): boolean {
    return type === "product_sale" || type === "ticket_sale" || type === "service_sale";
  }

  public selected(event) {
    this.languageChange.emit(event);
  }

  public onSubmit({ value, valid }) {
    this.submitAttempt = true;
    if (valid) {
      this.createOrUpdateWidget.emit(value);
    } else {
      this.utilities.consoleError("Form", this.form);
      this.utilities.setToast("Form widget contain errors", 3000, "top");
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets-right/widgets-right-form/widgets-right-form.ts